import axios from "axios"

// Fetch leads with pagination
export const fetchContactsLeads = async (page = 1, quantity = 10) => {
    try {
        let response = await axios({
            'method': 'get',
            'url': `https://api.wizhull.com/fetchContactLeads?page=${page}&quantity=${quantity}`
        })
        return {
            status: "success",
            data: response.data.data
        }
    } catch (err) {
        return {
            status: "failed",
            error: "Internal Error Occured: Failed fetching contacts leads"
        }
    }
}

export const fetchChatbotLeads = async (page = 1, quantity = 10) => {
    try {
        let response = await axios({
            'method': 'get',
            'url': `https://api.wizhull.com/fetchChatbotLeads?page=${page}&quantity=${quantity}`
        })
        return {
            status: "success",
            data: response.data.data
        }
    } catch (err) {
        return {
            status: "failed",
            error: "Internal Error Occured: Failed fetching chatbot leads"
        }
    }
}

export const fetchMortgageLeads = async (page = 1, quantity = 10) => {
    try {
        let response = await axios({
            'method': 'get',
            'url': `https://api.wizhull.com/fetchMortgageLeads?page=${page}&quantity=${quantity}`
        })
        return {
            status: "success",
            data: response.data.data
        }
    } catch (err) {
        return {
            status: "failed",
            error: "Internal Error Occured: Failed fetching mortgage leads"
        }
    }
}

export const fetchNewsletterLeads = async (page = 1, quantity = 10) => {
    try {
        let response = await axios({
            'method': 'get',
            'url': `https://api.wizhull.com/fetchNewsletterLeads?page=${page}&quantity=${quantity}`
        })
        return {
            status: "success",
            data: response.data.data
        }
    } catch (err) {
        return {
            status: "failed",
            error: "Internal Error Occured: Failed fetching newsletter"
        }
    }
}

// Fetch counts for overview
export const fetchChatbotLeadsCount = async () => {
    try {
        let response = await axios({
            'method': 'get',
            'url': `https://api.wizhull.com/fetchChatbotLeadsCount`
        })
        return {
            status: "success",
            data: response.data.data
        }
    } catch (err) {
        return {
            status: "failed",
            error: "Internal Error Occured: Failed fetching chatbot leads count"
        }
    }
}

export const fetchContactLeadsCount = async () => {
    try {
        let response = await axios({
            'method': 'get',
            'url': `https://api.wizhull.com/fetchContactLeadsCount`
        })
        return {
            status: "success",
            data: response.data.data
        }
    } catch (err) {
        return {
            status: "failed",
            error: "Internal Error Occured: Failed fetching contact leads count"
        }
    }
}

export const fetchMortgageLeadsCount = async () => {
    try {
        let response = await axios({
            'method': 'get',
            'url': `https://api.wizhull.com/fetchMortgageLeadsCount`
        })
        return {
            status: "success",
            data: response.data.data
        }
    } catch (err) {
        return {
            status: "failed",
            error: "Internal Error Occured: Failed fetching mortgage leads count"
        }
    }
}